import React from 'react'
import { Row, Col } from 'reactstrap'
import { CreateButton } from './createButton'
import { TrashButton } from './trashButton'
import { EmptyTrashButton } from './emptyTrashButton'

export const Buttons = (props) => {
  if (props.canCreate || props.canGoToTrash || props.canEmptyTrash) {
    return (
      <Row>
        <Col>
        <div className={props.classes.buttons}>
          <CreateButton {...props} />
          <TrashButton {...props} />
          <EmptyTrashButton {...props} />
        </div>
        </Col>
      </Row>
    )
  }
  return null
}
